import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Configuration from './components/config';
import DeleteTemplate from './components/DeleteTemplateModule/deleteTemplateModule';
import ViewUpdate from './components/ViewUpdateTaskModule/viewUpdateTaskModule';
import NewMessage from './components/NewMessage/newMessage';
import StatusTaskModule from './components/StatusTaskModule/statusTaskModule';
import './App.scss';
import SendConfirmationTaskModule from './components/SendConfirmationTaskModule/sendConfirmationTaskModule';
import VideoPlayerTaskModule from './components/VideoPlayerTaskModule/videoPlayerTaskModule';
import { app } from "@microsoft/teams-js";
import ErrorPage from "./components/ErrorPage/errorPage";
import SignInPage from "./components/SignInPage/signInPage";
import SignInSimpleStart from './components/SignInPage/signInSimpleStart';
import SignInSimpleEnd from './components/SignInPage/signInSimpleEnd';
import CommsCalender from './components/Calendar/calendar';
import HomePage from './components/CommunicatorContainer/communicatorContainer';
import { updateLocale } from './i18n';
import Initializer from './Initializer';
import { FluentProvider, teamsHighContrastTheme, teamsDarkTheme, teamsLightTheme } from '@fluentui/react-components'
import { initializeTeamsApp } from './helpers/teamsApp';

export interface IAppState {
  theme: string;
}

class App extends React.Component<{}, IAppState> {

  constructor(props: {}) {
    super(props);
    this.state = {
      theme: "",
    }
    }

    public componentDidMount() {
        const initializeTeams = async () => {
            await initializeTeamsApp(); // awaits the promise started in index.tsx

            const context = await app.getContext();
            const theme = context.app.theme || "default";
            this.setState({ theme });

            app.registerOnThemeChangeHandler((newTheme) => {
                this.setState({ theme: newTheme });
            });
        };

        initializeTeams().catch((error) => {
            console.error("Teams SDK failed to initialize.", error);
        });

        updateLocale();
    }

  public setThemeComponent = () => {
    if (this.state.theme === "dark") {
      return (
        <FluentProvider theme={teamsDarkTheme}>
          <div className="darkContainer">
            {this.getAppDom()}
          </div>
        </FluentProvider>
      );
    }
    else if (this.state.theme === "contrast") {
      return (
        <FluentProvider theme={teamsHighContrastTheme}>
          <div className="highContrastContainer">
            {this.getAppDom()}
          </div>
        </FluentProvider>
      );
    } else {
      return (
        <FluentProvider theme={teamsLightTheme}>
          <div className="defaultContainer">
            {this.getAppDom()}
          </div>
        </FluentProvider>
      );
    }
  }

  public getAppDom = () => {
    return (
      <>
        <Initializer />
        <Suspense fallback={<div></div>}>
          <div className="appContainer">
            <BrowserRouter>
              <Routes>
                <Route path="/configtab" element={<Configuration />} />
                <Route path="/homepage" element={<HomePage />} />
                <Route path="/deletetemplate/:id" element={<DeleteTemplate />} />
                <Route path="/messages" element={<HomePage />} />
                <Route path="/newmessage" element={<NewMessage />} />
                <Route path="/viewupdates" element={<ViewUpdate />} />
                <Route path="/newmessage/:id" element={<NewMessage />} />
                <Route path="/newmessage/:messagetype/:id" element={<NewMessage />} />
                <Route path="/newmessage/:date" element={<NewMessage />} />
                <Route path="/viewstatus/:id" element={<StatusTaskModule />} />
                <Route path="/viewvideo" element={<VideoPlayerTaskModule />} />
                <Route path="/sendconfirmation/:id" element={<SendConfirmationTaskModule />} />
                <Route path="/errorpage" element={<ErrorPage />} />
                <Route path="/errorpage/:id" element={<ErrorPage />} />
                <Route path="/signin" element={<SignInPage />} />
                <Route path="/signin-simple-start" element={<SignInSimpleStart />} />
                <Route path="/signin-simple-end" element={<SignInSimpleEnd />} />
                <Route path="/commsCalendar" element={<CommsCalender />} />
              </Routes>
            </BrowserRouter>
          </div>
        </Suspense>
        </>
    );
  }

  public render(): JSX.Element {
    return (
      <div>
        {this.setThemeComponent()}
      </div>
    );
  }
}

export default App;